import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import React from "react";

const InsightsFormHandler = ({ hasChanges, saving, handleFormCancel, styles = {} }) =>
  hasChanges ? (
    <MDBox
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        ...styles,
      }}
    >
      <MDButton
        color="gray80"
        onClick={handleFormCancel}
        disabled={saving}
        sx={{
          marginRight: "1rem",
        }}
      >
        Cancel
      </MDButton>
      <MDButton color="primaryRed" type="submit" disabled={saving}>
        Save
      </MDButton>
    </MDBox>
  ) : null;

export default InsightsFormHandler;
